import PaymentLinkCart from './PaymentLinkCart';

export default PaymentLinkCart;
